import { Col, Row } from "antd";
import { t } from "i18next";
import React, { useContext, useMemo } from "react";

import { MinistryContext } from "../../../../modules/ministry/ministry.context";
import { IDozvolaZahteviDostavljeniDokaziProps } from "../../../../modules/ministry/ministry.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../modules/obligee/exciseStamps/exciseStamps.types";
import style from "./Documentation.module.scss";
import { DocumentReadOnly } from "./components/DocumentReadOnly/DocumentReadOnly";

interface IDocumentationProps {
  data?: IDozvolaZahteviDostavljeniDokaziProps[];
  kategorijaProizvodaId?: AkciznaMarkicaKategorijaProzivoda | null;
}

export const Documentation: React.FC<IDocumentationProps> = ({
  kategorijaProizvodaId,
  data,
}) => {
  const { ministry } = useContext(MinistryContext);

  // const DocumentType1 = data?.find(
  //   (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 1
  // );
  const DocumentType2 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 2
  );
  const DocumentType3 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 3
  );
  const DocumentType4 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 4
  );
  // const DocumentType5 = data?.find(
  //   (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 5
  // );
  const DocumentType6 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 6
  );
  const DocumentType7 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) => dokument.tip === 7
  );

  const evidencioniBroj = useMemo(() => {
    return (
      ministry.detaljiODozvoli?.evidencioniBroj ||
      ministry.detaljiOSkladistu?.evidencioniBroj
    );
  }, [
    ministry.detaljiODozvoli?.evidencioniBroj,
    ministry.detaljiOSkladistu?.evidencioniBroj,
  ]);

  return (
    <Col span={24} className={style.mainContainer}>
      <Col span={24} className={style.title}>
        {t("AKCIZNE_DOZVOLE.DOKUMENTACIJA")}
      </Col>
      <Row>
        <Col span={11} className="pr-55">
          {/* <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={1}
                data={DocumentType1 || null}
                title={t(
                  "AKCIZNE_DOZVOLE.IZJAVA_DA_LI_ISPUNJAVA_USLOVE_ZA_ELEKTRONSKU_RAZMENU_PODATAKA"
                )}
              />
            </Col>
          </Row> */}
          <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={3}
                data={DocumentType3 || null}
                title={t("AKCIZNE_DOZVOLE.DOKAZ_O_VLASNISTVU_ZAKUPU")}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType3?.dokumentUrl}`
                    : ""
                }
                disabled={true}
              />
            </Col>
          </Row>
          {/* <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={5}
                data={DocumentType5 || null}
                title="Upisan u registar proizvođača"
              />
            </Col>
          </Row> */}
          <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={7}
                data={DocumentType7 || null}
                title={t(
                  "AKCIZNE_DOZVOLE.DOKAZ_O_IZVRSENOM_POPISU_AKCIZNIH_PROIZVODA"
                )}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType7?.dokumentUrl}`
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={4}
                data={DocumentType4 || null}
                title={t("AKCIZNE_DOZVOLE.POSTUPAK_STECAJA_ILI_LIKVIDACIJE")}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType4?.dokumentUrl}`
                    : ""
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={11} className="pl-85">
          <Row>
            {kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE ? (
              <Col span={24}>
                <DocumentReadOnly
                  tip={2}
                  data={DocumentType2 || null}
                  title={t(
                    "AKCIZNE_DOZVOLE.ODOBRENJE_OD_STRANE_ORGANA_NADLEZNOG_ZA_MERE_ZA_KORISCENJE_MERNOG_UREDJAJA"
                  )}
                  dokumentName={
                    evidencioniBroj
                      ? `${evidencioniBroj}-${DocumentType2?.dokumentUrl}`
                      : ""
                  }
                />
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col span={24}>
              <DocumentReadOnly
                tip={6}
                data={DocumentType6 || null}
                title={t(
                  "AKCIZNE_DOZVOLE.KRIVICNI_POSTUPAK_PROTIV_ODGOVORNOG_LICA"
                )}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType6?.dokumentUrl}`
                    : ""
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};
